/* import __COLOCATED_TEMPLATE__ from './seller-profile-reviews.hbs'; */
import { A } from '@ember/array';
import { computed } from '@ember/object';
import { empty } from '@ember/object/computed';
import Component from '@ember/component';
import {
  SELLER_PROFILE__REVIEWS_BACKGROUND_CLASS
} from "../../constants/components/profile";

export default Component.extend({
  /**
   * HTML Component properties
   */
  tagName: 'section',
  classNames: [SELLER_PROFILE__REVIEWS_BACKGROUND_CLASS],
  classNameBindings: ['_hasNoReviews:hide'],

  /** @param {User} user */
  user: null,

  /**
   * @type {Boolean}    True when the user has no reviews
   */
   _hasNoReviews: empty('_reviewScoresToShow'),  
  /** @type {Ember.A<ServiceUserScore>} The subset of scores based on certain criteria. */
  _reviewScoresToShow: computed('user.serviceUserScores.[]', function () {
    const freelancerReviewScores = this.user.serviceUserScores;

    if (!freelancerReviewScores) {
      return A([]);
    }

    return freelancerReviewScores.filter((reviewScore) => reviewScore.score > 0);
  })
});
